import ModalFirstAskNotification from './ModalFirstAskNotification';

export default ModalFirstAskNotification;
